module.exports = __webpack_public_path__ + "static/media/check_circle.6b985c11.png";